// extracted by mini-css-extract-plugin
export default {"variant-btn":"Variant_variant-btn__vn1UC","variant-btn-center":"Variant_variant-btn-center__kZxU4"};